import { render } from "./PoiDetail.vue?vue&type=template&id=299335f5&scoped=true"
import script from "./PoiDetail.vue?vue&type=script&lang=js"
export * from "./PoiDetail.vue?vue&type=script&lang=js"

import "./PoiDetail.vue?vue&type=style&index=0&id=299335f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-299335f5"]])

export default __exports__